import { StyleSheet } from 'react-native';
import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

export default StyleSheet.create({
    content: {
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row'
    },
    input: {
        paddingHorizontal: 5,
        flex: 1,
        height: 34,
        padding: 0,
        backgroundColor: Colors.white,
        margin: 0,
        borderRadius: 5
    },
    btn: {
        paddingVertical: Layout.gutterMin,
        paddingHorizontal: Layout.gutterSmall
    },
    iconSearch: {
        color: Colors.greyDark
    }
});
